export default __webpack_public_path__ + "static/media/Feed Chute.06431e87.jpg";